webpackJsonp([81],{

/***/ 1101:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(114);

var _ButtonLink = __webpack_require__(590);

var _ButtonLink2 = _interopRequireDefault(_ButtonLink);

var _NewFooterV = __webpack_require__(572);

var _NewFooterV2 = _interopRequireDefault(_NewFooterV);

var _Heading = __webpack_require__(595);

var _Heading2 = _interopRequireDefault(_Heading);

var _Heading3 = __webpack_require__(593);

var _Heading4 = _interopRequireDefault(_Heading3);

__webpack_require__(1101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageNotFound = function (_Component) {
    _inherits(PageNotFound, _Component);

    function PageNotFound(props) {
        _classCallCheck(this, PageNotFound);

        var _this = _possibleConstructorReturn(this, (PageNotFound.__proto__ || Object.getPrototypeOf(PageNotFound)).call(this, props));

        _this.state = {
            referrer: ''
        };
        return _this;
    }

    _createClass(PageNotFound, [{
        key: 'setReferrer',
        value: function setReferrer() {
            this.setState({
                referrer: document.referrer || 'https://mercos.com'
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.setReferrer();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _react.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'not-found-container new-not-found-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'container' },
                        _react2.default.createElement('img', { className: 'logo-mercos', src: '/images/logo-mercos-white.svg', alt: 'Logomarca Mercos' }),
                        _react2.default.createElement(
                            'h2',
                            { center: true },
                            'Oooops...'
                        ),
                        _react2.default.createElement(
                            'h1',
                            { center: true },
                            'Essa p\xE1gina n\xE3o existe, voc\xEA digitou o endere\xE7o certo?'
                        ),
                        _react2.default.createElement(
                            'a',
                            { href: this.state.referrer, center: true, radius: 'half-rounded', title: 'Voltar para a p\xE1gina anterior.' },
                            ' \u2039 VOLTAR PARA A P\xC1GINA ANTERIOR'
                        )
                    ),
                    _react2.default.createElement('img', { className: 'not-found-illustration', alt: 'A p\xE1gina que voc\xEA tentou acessar n\xE3o est\xE1 dispon\xEDvel.', src: '/images/site/new-page-not-found-illustration.svg' })
                )
            );
        }
    }]);

    return PageNotFound;
}(_react.Component);

exports.default = PageNotFound;

/***/ }),

/***/ 551:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.createUrlsParamBasedOnCookies = createUrlsParamBasedOnCookies;
exports.redirectWithCookies = redirectWithCookies;

var _jsCookie = __webpack_require__(552);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createUrlsParamBasedOnCookies() {
	var campain = _jsCookie2.default.get('mutm_campaign');
	var medium = _jsCookie2.default.get('mutm_medium');
	var source = _jsCookie2.default.get('mutm_source');
	var term = _jsCookie2.default.get('mutm_term');
	var content = _jsCookie2.default.get('mutm_content');
	var fbclid = _jsCookie2.default.get('mfbclid');
	var gclid = _jsCookie2.default.get('mgclid');
	if (campain || medium || source) {
		var params = campain ? '&utm_campaign=' + campain : '';
		params += medium ? '&utm_medium=' + medium : '';
		params += source ? '&utm_source=' + source : '';
		params += term ? '&utm_term=' + term : '';
		params += content ? '&utm_content=' + content : '';
		params += fbclid ? '&fbclid=' + fbclid : '';
		params += gclid ? '&gclid=' + gclid : '';
		return '?' + params.slice(1);
	}
	return '';
}

function redirectWithCookies(url) {
	var paramsCookie = createUrlsParamBasedOnCookies();
	var currentURL = window.location.href;

	_jsCookie2.default.set('trial_page_ref', currentURL, { domain: '.mercos.com' });
	window.location = '' + url + paramsCookie;
}

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 572:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = NewFooter;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(573);

var _Utm = __webpack_require__(553);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NewFooter() {
    var footerSections = [{
        title: 'Mercos',
        links: [{ name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true }, { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true }, { name: 'Integrações', url: '/integracao-erp/' }, { name: 'Carreira', url: 'https://mercos.gupy.io/' }, { name: 'Sobre Nós', url: '/sobre/' }]
    }, {
        title: 'Soluções',
        links: [{ name: 'Força de vendas', url: '/forca-vendas/' }, { name: 'E-commerce B2B', url: '/e-commerce-b2b/', highlight: true }, { name: 'Aplicativo de vendas', url: '/aplicativo-vendas/' }, { name: 'Mercos Pay', url: '/mercos-pay', highlight: true }, { name: 'Videochamada', url: '/videochamada/' }]
    }, {
        title: 'Segmentos',
        links: [{ name: 'Indústrias', url: '/industrias/' }, { name: 'Distribuidoras', url: '/distribuidoras/' }, { name: 'Representantes', url: '/representantes-comerciais/' }]
    }, {
        title: 'Conteúdo',
        links: [{ name: 'Blog', url: 'https://blog.mercos.com/' }, { name: 'Mercoscast', url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI' }, { name: _react2.default.createElement(
                _react.Fragment,
                null,
                'E-commerce B2B: ',
                _react2.default.createElement('br', null),
                ' O que \xE9?'
            ), url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e', target: '_blank' }]
    }, {
        title: 'Suporte',
        links: [{ name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb' }, {
            name: '(47) 3481.8050',
            custom: true,
            content: _react2.default.createElement(
                'div',
                { className: 'support-info' },
                _react2.default.createElement(
                    'div',
                    { className: 'support-phone' },
                    '(47) 3481.8050'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'support-hours' },
                    'Atendimento de Segunda',
                    _react2.default.createElement('br', null),
                    'a Quinta das 9h \xE0s 17h.',
                    _react2.default.createElement('br', null),
                    'Sexta das 9h30 \xE0s 17h.'
                )
            )
        }]
    }, {
        title: 'Transparência',
        links: [{ name: 'Termos e Condições', url: '/termos-e-condicoes/', target: '_blank' }, { name: 'Aviso de privacidade', url: '/aviso-de-privacidade/', target: '_blank' }, { name: 'Portal da Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', target: '_blank' }, { name: 'Relatório da igualdade salarial', url: '/documentos/relatorio-igualdade-salarial-mercos.pdf' }]
    }];

    var renderLink = function renderLink(link) {
        if (link.custom) {
            return link.content;
        }

        return _react2.default.createElement(
            'a',
            {
                className: 'footer-link ' + (link.highlight ? 'highlight' : ''),
                href: link.redirect ? null : link.url,
                onClick: link.redirect ? function () {
                    return (0, _Utm.redirectWithCookies)(link.url);
                } : null,
                target: link.target || null,
                rel: link.target === '_blank' ? 'noopener noreferrer' : null
            },
            link.name
        );
    };

    var socialLinks = [{ name: 'Facebook', url: 'https://www.facebook.com/mercosoficial', icon: '/images/site/social/facebook.svg' }, { name: 'YouTube', url: 'https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw', icon: '/images/site/social/youtube.svg' }, { name: 'Instagram', url: 'https://www.instagram.com/mercosoficial/', icon: '/images/site/social/instagram.svg' }, { name: 'LinkedIn', url: 'https://www.linkedin.com/company/mercos/mycompany/', icon: '/images/site/social/linkedin.svg' }, { name: 'Spotify', url: 'https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1', icon: '/images/site/social/spotify.svg' }];

    return _react2.default.createElement(
        'footer',
        { className: 'mercos-footer' },
        _react2.default.createElement(
            'div',
            { className: 'footer-content' },
            _react2.default.createElement(
                'div',
                { className: 'footer-main' },
                footerSections.map(function (section, index) {
                    return _react2.default.createElement(
                        'div',
                        { className: 'footer-section', key: index },
                        _react2.default.createElement(
                            'p',
                            { className: 'section-title' },
                            section.title
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: 'section-links' },
                            section.links.map(function (link, linkIndex) {
                                return _react2.default.createElement(
                                    'div',
                                    { className: 'link-item', key: linkIndex },
                                    renderLink(link)
                                );
                            })
                        )
                    );
                })
            ),
            _react2.default.createElement(
                'div',
                { className: 'footer-app-download' },
                _react2.default.createElement(
                    'div',
                    { className: 'download-text' },
                    _react2.default.createElement(
                        'p',
                        { className: 'download-title' },
                        'Baixe o aplicativo e teste gr\xE1tis'
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        'Junte-se a mais de 8,5 mil clientes que automatizaram e aumentaram suas vendas com a Mercos.'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'app-buttons' },
                    _react2.default.createElement(
                        'a',
                        { href: 'https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                        _react2.default.createElement('img', { src: '/images/site/social/google-play.png', alt: 'Dispon\xEDvel no Google Play' })
                    ),
                    _react2.default.createElement(
                        'a',
                        { href: 'https://apps.apple.com/br/app/mercos-app-de-vendas/id485511628', target: '_blank', rel: 'noopener noreferrer', className: 'app-button' },
                        _react2.default.createElement('img', { src: '/images/site/social/app-store.png', alt: 'Baixar na App Store' })
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'footer-bottom' },
                _react2.default.createElement('div', { className: 'footer-hr-line' }),
                _react2.default.createElement(
                    'div',
                    { className: 'footer-container' },
                    _react2.default.createElement(
                        'div',
                        { className: 'logo-container' },
                        _react2.default.createElement(
                            'a',
                            { href: '/', className: 'mercos-logo' },
                            _react2.default.createElement('img', { src: '/images/mercos-nuvini.svg', alt: 'Mercos - uma empresa nuvini' })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'company-info' },
                        'Simplest Software Ltda CNPJ: 12.496.510/0001-80 Insc. Estadual: ISENTO Av. Rolf Wiest, 277 (7\xBA andar) Bom Retiro - Joinville/SC | CEP: 89223-005'
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'social-links' },
                        socialLinks.map(function (social, index) {
                            return _react2.default.createElement(
                                'a',
                                {
                                    key: index,
                                    href: social.url,
                                    target: '_blank',
                                    rel: 'noopener noreferrer',
                                    className: 'social-link',
                                    'aria-label': social.name
                                },
                                _react2.default.createElement('img', { src: social.icon, alt: 'Mercos no ' + social.name })
                            );
                        }),
                        _react2.default.createElement(
                            'span',
                            { className: 'feito-com-amor' },
                            'Feito com \uD83D\uDC9C'
                        )
                    )
                )
            )
        )
    );
}

/***/ }),

/***/ 573:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(551);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(564);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonLink = function ButtonLink(_ref) {
    var children = _ref.children,
        color = _ref.color,
        model = _ref.model,
        size = _ref.size,
        radius = _ref.radius,
        className = _ref.className,
        _ref$href = _ref.href,
        href = _ref$href === undefined ? '/' : _ref$href,
        target = _ref.target,
        rel = _ref.rel,
        title = _ref.title,
        onClick = _ref.onClick,
        style = _ref.style,
        onMouseEnter = _ref.onMouseEnter,
        onMouseLeave = _ref.onMouseLeave,
        shake = _ref.shake;
    return _react2.default.createElement(
        'a',
        { className: (0, _classnames2.default)('button', model, size, radius, className, color, shake && 'shake'),
            href: href,
            target: target,
            title: title,
            onClick: onClick,
            style: style,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            rel: rel ? rel : target === '_blank' ? 'noopener noreferrer' : '' },
        children
    );
};

ButtonLink.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.any,
    color: _propTypes2.default.string,
    href: _propTypes2.default.string,
    model: _propTypes2.default.oneOf(['outline', 'secondary', 'success', 'alert', 'warning']),
    radius: _propTypes2.default.oneOf(['half-rounded', 'all-rounded', 'left-rounded', 'right-rounded', 'not-rounded']),
    size: _propTypes2.default.string,
    target: _propTypes2.default.oneOf(['_blank', '_parent', '_self', '_top']),
    title: _propTypes2.default.string
};

exports.default = ButtonLink;

/***/ }),

/***/ 593:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(551);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(558);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading4 = function Heading4(_ref) {
    var children = _ref.children,
        center = _ref.center,
        white = _ref.white,
        gray = _ref.gray,
        bottomSpace = _ref.bottomSpace,
        className = _ref.className;
    return _react2.default.createElement(
        'h4',
        { className: (0, _classnames2.default)('heading4', className, center ? 'text-center' : '', white ? 'heading-white' : '', gray ? 'heading-gray' : '', bottomSpace ? 'bottom-space' : '') },
        children
    );
};

exports.default = Heading4;

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(551);

var _classnames2 = _interopRequireDefault(_classnames);

__webpack_require__(558);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Heading1 = function Heading1(_ref) {
    var children = _ref.children,
        white = _ref.white,
        center = _ref.center,
        className = _ref.className,
        left = _ref.left,
        style = _ref.style,
        purple = _ref.purple,
        black = _ref.black;
    return _react2.default.createElement(
        'h1',
        { style: style,
            className: (0, _classnames2.default)('heading1', className, white && 'heading-white', center && 'text-center', left && 'text-left', purple && 'heading-purple', black && 'heading-black') },
        children
    );
};

exports.default = Heading1;

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/404v2.jsx.80d5f7e6.js